import React from 'react';
import { Box, Grid, FormControlLabel, Checkbox } from '@material-ui/core'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { CardDb } from '../redux/cardDbSlice';
import { MemoCardContentDb } from '../redux/memoCardContentDbSlice';
import { deepCopy } from '../general';
import ColorPalette from '../components/ColorPalette';

type EditMemoCardProps = {
  card: CardDb;
  setCard: (card: CardDb) => void;
  memoContent: MemoCardContentDb;
  setMemoContent: (content: MemoCardContentDb) => void;
}
const EditMemoCard: React.FC<EditMemoCardProps> = ({card, setCard, memoContent, setMemoContent}) => {
  const toolbarOptions = [
    [{ 'header': [1, 2, false] }],
    ['bold', 'italic', 'underline','strike', 'blockquote'],
    [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
    ['link', 'image'],
    ['clean'],
    [{'color': []}]
  ];
  const modules = {
    toolbar: toolbarOptions
  };
  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image',
    'color'
  ];
  const changeBackgroundDisplay = (display: boolean) => {
    const newCard = deepCopy(card);
    newCard.background.display = display;
    setCard(newCard);
  }
  const changeBackgroundColor = (color: string) => {
    const newCard = deepCopy(card);
    newCard.background.color = color;
    setCard(newCard); 
  }
  const changeShadowDisplay = (display: boolean) => {
    const newCard = deepCopy(card);
    newCard.shadow = display;
    setCard(newCard);
  }

  return (
     <Box>
      <div style={{height: 300}}>
        <ReactQuill theme="snow" style={{height: "80%"}}
          value={memoContent.content ?? ''}
          onChange={value => setMemoContent({...memoContent, content: value})}
          modules={modules}
          formats={formats}
        />
      </div>
      <Grid container alignItems="center">
        <Grid item container alignItems="center" xs={12} md={4}>
          <FormControlLabel label="枠線表示"
            control={
              <Checkbox checked={card.frame.display} color="primary"
                onChange={(ev) => setCard({...card, frame: {...card.frame, display: ev.currentTarget.checked}})} />
            } />
          <ColorPalette
            currentValue={card.frame.color}
            onChange={value => setCard({ ...card, frame: { ...card.frame, color: value } })}
            disabled={!card.frame.display}
          />
        </Grid>
        <Grid item container alignItems="center" xs={12} md={4}>
          <FormControlLabel label="背景表示"
            control={
              <Checkbox checked={card.background.display} color="primary"
                onChange={(ev) => changeBackgroundDisplay(ev.currentTarget.checked)} />
            } />
          <ColorPalette
            currentValue={card.background.color}
            onChange={changeBackgroundColor}
            disabled={!card.background.display}
          />
        </Grid>
        <Grid item xs={12} md={4}>
              <FormControlLabel label="影あり"
                control={
                  <Checkbox checked={card.shadow} color="primary"
                    onChange={(ev) => changeShadowDisplay(ev.currentTarget.checked)} />
              } />
        </Grid>
      </Grid>
    </Box>
  );
}

export default EditMemoCard;
